/* global axios */
import WhatsAppSipApiClient from './index';

class WhatsAppSipCallEventsAPI extends WhatsAppSipApiClient {
  constructor() {
    super('call_events');
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/call_events
  getCallEvents(params = {}) {
    return axios.get(this.url, { params });
  }

  // GET /api/v1/accounts/:account_id/whatsapp_sip/call_events/by-channel/:channelId
  getByChannel(channelId) {
    return axios.get(`${this.url}/by-channel/${encodeURIComponent(channelId)}`);
  }
}

export default new WhatsAppSipCallEventsAPI();
